import React from 'react';
import {
  View,
  Image,
  ScrollView,
  ImageBackground,
  TouchableWithoutFeedback,
} from 'react-native';
import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { IReviewImageTriggerProps } from './types';
import { BodyText } from '../../../ui';
import iconChevronRightUrl from '../../../../../images/icons/icon-chevron-white-right.svg';
import { IGalleryImage } from '../../../../api/Providers/GalleryImages';
import { clickable } from '../../../../styles';

const overlayColor = 'rgba(0, 0, 0, 0.4)';

/**
 * This renders the trigger mini-gallery with 4 images and a see more button
 * which when clicked calls open of the wrapping modal trigger.
 * @param onShowMore
 * @param previewImages
 * @constructor
 */
export default function ReviewImageSummaryTrigger({
  onShowMore,
  previewImages,
}: IReviewImageTriggerProps) {
  const shownImages: IGalleryImage[] = previewImages.slice(0, 4);
  const hasMoreImages: boolean = previewImages.length > shownImages.length;

  const handleShowMorePress = React.useCallback((index: number) => {
    onShowMore(index);
  }, [onShowMore]);

  return (
    <ScrollView horizontal>
      <Inline
        space={4}
        paddingRight={8}
        testID="review-image-summary-trigger"
      >
        {shownImages.map((image: IGalleryImage, index) => (
          <Inline
            space={8}
            key={image.id}
          >
            <TouchableWithoutFeedback onPress={() => handleShowMorePress(index)}>
              <ImageBackground
                style={[
                  {
                    width: 124,
                    height: 124,
                  },
                  clickable,
                ]}
                source={{ uri: `${image.url}_200x200.jpg` }}
              >
                {index >= shownImages.length - 1 && hasMoreImages && (
                  <TouchableWithoutFeedback onPress={() => handleShowMorePress(index)}>
                    <View
                      style={[
                        {
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                          position: 'absolute' as 'absolute',
                          top: 0,
                          bottom: 0,
                          left: 0,
                          right: 0,
                          backgroundColor: overlayColor,
                        },
                        clickable,
                      ]}
                    >
                      <BodyText
                        weight="bold"
                        color={colors.whiteWash}
                      >
                        See All
                      </BodyText>
                      <Image
                        style={{
                          width: 20,
                          height: 20,
                        }}
                        source={iconChevronRightUrl}
                      />
                    </View>
                  </TouchableWithoutFeedback>
                )}
              </ImageBackground>
            </TouchableWithoutFeedback>
          </Inline>
        ))}
      </Inline>
    </ScrollView>
  );
}
